import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// מונע שינוי גודל טקסט אוטומטי במובייל
const preventTextSizeAdjust = () => {
  const viewport = document.querySelector('meta[name="viewport"]');
  if (viewport) {
    viewport.content = 'width=device-width, initial-scale=1, maximum-scale=1';
  } else {
    const meta = document.createElement('meta');
    meta.name = 'viewport';
    meta.content = 'width=device-width, initial-scale=1, maximum-scale=1';
    document.head.appendChild(meta);
  }
};

// הפעלת הפונקציה
preventTextSizeAdjust();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
